@if (viewMedia.viewMedia()?.show) {
    <tec-modal
        [isVisible]="true"
        [hideHeader]="true"
        type="large"
        (closeEvent)="viewMedia.hide()"
    >
        <ng-container body>
            <div class="view-media-shell">
                @if (canViewDeveloperCurl() && viewMedia.viewMedia()?.developerCurl?.path) {
                    <tec-button-icon
                        class="view-media-shell__curl"
                        icon="icon-code-brackets"
                        type="default"
                        (clickEvent)="openViewMediaCurl()"
                    />
                }
                <tec-view-media [viewMedia]="viewMedia.viewMedia()!" (closeEvent)="viewMedia.hide()" />
            </div>
        </ng-container>
    </tec-modal>
}

@if (viewMediaCurlOpen()) {
    <app-modal-curl-request
        [titleKey]="viewMediaCurlTitleKey()"
        [curlText]="viewMediaCurlText()"
        (closeEvent)="closeViewMediaCurl()"
    />
}
@if (languageModalOpen()) {
    <tec-modal
        [isVisible]="true"
        [title]="'GENERAL.LANGUAGE' | translate"
        [tagImage]="{ icon: 'icon-language' }"
        [buttonPrimaryLabel]="'BUTTON.SAVE' | translate"
        [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
        (closeEvent)="closeLanguageModal($event)"
    >
        <ng-container body>
            <tec-form-group [label]="'GENERAL.SELECT_LANGUAGE' | translate">
                <tec-toggle
                    [options]="languageToggleOptions"
                    [ngModel]="selectedLang"
                    (ngModelChange)="selectedLang = $event"
                    [multiple]="false"
                    [requireSelection]="true"
                />
            </tec-form-group>
        </ng-container>
    </tec-modal>
}
@if (!errorService?.generalError().show) {
    <tec-base [hidden]="viewMedia.viewMedia()?.show">
        @if (!isProduction && !viewMedia.viewMedia()?.show) {
            <tec-alert
                class="int-tec-alert"
                type="message"
                status="warning"
                icon="icon-package"
                [msg]="'GENERAL.TEST_MODE' | translate"
                [hiddenCloseButton]="true"
            />
        }
        <tec-topnav [img]="'images/tecalis-lg.svg'" [title]="'Identity'" [menu]="tabletMenu()">
            @if (user?.legacy_user_exists) {
                <tec-link [href]="legacyAdminUrl" target="_self">
                    {{ 'GENERAL.IDENTITY_LEGACY' | translate }}
                </tec-link>
            }
            <tec-menu
                [options]="[
                        {
                            label: 'GENERAL.LANGUAGE' | translate,
                            icon: 'icon-language',
                            id: 'language',
                        },
                        {
                            label: 'GENERAL.TECALIS_ACCOUNT' | translate,
                            icon: 'icon-external-link',
                            id: 'tecalisAccount',
                        },
                        {
                            label: 'GENERAL.CLOSE_SESSION' | translate,
                            icon: 'icon-log-out',
                            id: 'logout',
                            style: 'red',
                            divider: true,
                        },
                    ]"
                (valueChange)="menuChange($event)"
            >
                <tec-avatar
                    [avatar]="{
                        id: user?.data?.uuid,
                        name: ((user?.data?.name || '') + ' ' + (user?.data?.surname || '')).trim() || user?.data?.email,
                        tooltip: user?.data?.email
                    }"
                ></tec-avatar>
            </tec-menu>
        </tec-topnav>

        @if (!tabletSize()) {
            <tec-sidenav [confSidenav]="sidenavConfig()">
                @if (operationBalance(); as bal) {
                    <ng-container bottom-section>
                        <button
                            type="button"
                            class="operation-balance-trigger"
                            (click)="openOperationBalanceModal()"
                        >
                            <tec-tile styling="thin">
                                <tec-progress
                                    [value]="bal.percent"
                                    [label]="'SIDENAV.OPERATIONS_BALANCE' | translate"
                                    [description]="
                                        'SIDENAV.OPERATIONS_BALANCE_DESC'
                                            | translate: { consumed: bal.consumed, purchased: bal.purchased }
                                    "
                                />
                            </tec-tile>
                        </button>
                    </ng-container>
                }
            </tec-sidenav>
        }

        @if (operationBalance(); as bal) {
            <app-operation-balance-modal
                [isVisible]="operationBalanceModalOpen()"
                [packName]="bal.packName"
                [items]="bal.items"
                (closeEvent)="closeOperationBalanceModal()"
            />
        }

        @if (user) {
            <router-outlet id="content"></router-outlet>
        }
    </tec-base>
}

<!-- Error -->
<ng-container *ngIf="errorService?.generalError() as generalError">
    <tec-empty-state
        *ngIf="generalError.show"
        [title]="'ERRORS.GENERIC_TITLE' | translate"
        [description]="'ERRORS.GENERIC_DESCRIPTION' | translate"
        [size]="'default'"
        [labelAction]="'BUTTON.RETRY' | translate"
        [type]="'error'"
        (clickEvent)="generalError.action()"
    ></tec-empty-state>
</ng-container>
